export default {
    id: "d6f75b60-ffd8-412a-ab7b-917ec23c80f7",
    icon: "mdi-view-carousel",
    name: "carousel",
    title: "Carousel",
    description: "A block carousel",
}